module.exports = __webpack_public_path__ + "static/media/sfyg-swipe-averaging.c4217d8a.png";